<h1 mat-dialog-title>{{ "" + data.title + "" | translate }}</h1>
<div mat-dialog-content>
    <div class="error" *ngIf="data.isError">{{ "" + data.message + "" | translate}}</div>
    <div class="info" *ngIf="!data.isError">{{ "" + data.message + "" | translate}}</div>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false" [hidden]="!isConfirmDialog">{{
        "element.permissionMessages.title.cancel" | translate}}</button>
    <button mat-button [mat-dialog-close]="true">OK</button>
</div>